import React from 'react';
import { Container } from '../styles/center';

const Images = () => {
  return (
    <Container>
      <h1>Képek</h1>
    </Container>
  );
};

export default Images;
